import React from 'react';
import { Form } from 'antd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { shouldUpdateCompare } from 'utils/utils2';
import UsersList from 'components/UsersList';

export type TypeReceiverSelectProps = {
  label?: string;
  disabled?: boolean;
};

const TypeReceiverSelect = ({
  label = '',
  disabled,
}: TypeReceiverSelectProps) => {
  return (
    <>
      <Form.Item shouldUpdate noStyle>
        {({ setFieldsValue }) => (
          <FormInput
            col
            xs={24}
            lg={6}
            name={`${label}receivertype`}
            rules={[
              {
                required: true,
                message: 'Rate Request Receiver Profile is required',
              },
            ]}
          >
            <ParListSelect
              parcode="RECEIVTYPE"
              onChange={() => {
                setFieldsValue({
                  [`${label}receiverroleprofile`]: null,
                  [`${label}receiverid`]: null,
                });
              }}
              allowClear
              disabled={disabled}
            />
          </FormInput>
        )}
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={shouldUpdateCompare(`${label}receivertype`)}
      >
        {({ getFieldValue }) => {
          const receivertype = getFieldValue(`${label}receivertype`);
          if (
            receivertype === 'UPROFILE' ||
            receivertype === 'UROLE' ||
            receivertype === 'USERJOB'
          )
            return (
              <FormInput
                col
                xs={24}
                lg={6}
                name={`${label}receiverroleprofile`}
                rules={[
                  {
                    required: true,
                    message: 'Rate Request Receiver Profile is required',
                  },
                ]}
              >
                <ParListSelect
                  parcode={receivertype === 'UROLE' ? 'UROLE' : 'USERJOB'}
                  allowClear
                  disabled={disabled}
                />
              </FormInput>
            );
          else if (receivertype === 'USER')
            return (
              <FormInput
                col
                xs={24}
                lg={6}
                name={`${label}receiverid`}
                rules={[
                  {
                    required: true,
                    message: 'Rate Request Receiver Profile is required',
                  },
                ]}
              >
                <UsersList disabled={disabled} />
              </FormInput>
            );
        }}
      </Form.Item>
    </>
  );
};

export default TypeReceiverSelect;
